import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: {
            "hero": {
                "title1": "Super AI",
                "title2": "for Every Generation",
                "desc": "Experience the power of boundless AI. Neo AI offers a complete solution for your application management and creativity with lightning speed.",
                "ctaPrimary": "Start Free Now",
                "ctaDashboard": "Go to Dashboard →",
                "ctaChecking": "Checking...",
                "ctaChecking": "Checking...",
                "ctaSecondary": "About Us"
            },
            "modelsMarquee": {
                "title": "World-Class Engines",
                "subtitle": "Access the most powerful generation models."
            },
            "common": {
                "credits": "Credits",
                "credit": "Credit",
                "findInspiration": "Find Inspiration"
            },
            "nav": {
                "home": "Home",
                "about": "About",
                "blog": "Blog",
                "blog": "Blog",
                "login": "Login",
                "language": "Language"
            },
            "blogPage": {
                "title": "Latest",
                "titleHighlight": "Insights",
                "description": "Learn tips, tricks, and the latest news about artificial intelligence.",
                "searchPlaceholder": "Search articles...",
                "allTopics": "All Topics",
                "noResultsTitle": "Not found",
                "noResultsDesc": "Try other keywords or change category filter.",
                "page": "Page",
                "of": "of",
                "readMore": "Read More"
            },
            "aboutPage": {
                "heroLabel": "About NeoAI",
                "heroTitle": "AI Platform for faster content creation.",
                "heroDesc": "NeoAI is a SaaS platform that helps creators, marketers, and businesses generate content, manage credits, and track performance with a simple yet powerful interface — without technical headaches.",
                "visionLabel": "OUR VISION",
                "visionText": "To be the most practical and affordable AI assistant to help users in Indonesia create content and manage digital activities without hassle — all from one dashboard.",
                "missionLabel": "OUR MISSION",
                "mission1Title": "01. Practical Tools",
                "mission1Text": "Providing easy-to-use AI tools for daily needs like social media, copywriting, and content ideas.",
                "mission2Title": "02. Full Control",
                "mission2Text": "Giving users full control through a credit system, transaction history, and transparent affiliate program.",
                "mission3Title": "03. Best Experience",
                "mission3Text": "Building a tidy, lightweight, and comfortable dashboard experience accessible from various devices.",
                "valuesLabel": "CORE VALUES",
                "value1Title": "Simple & Clear",
                "value1Text": "Focus on what users actually use. Not over-complicated, not too many buttons.",
                "value2Title": "Measurable & Transparent",
                "value2Text": "Every top up, credit usage, even affiliate commission can be tracked from the dashboard in real-time.",
                "value3Title": "Grow Together",
                "value3Text": "Affiliate & new features are built so users can also grow, not just consume.",
                "backHome": "Back to Home"
            },
            "login": {
                "title": "Log in to Neo AI",
                "description": "Use your Google account for quick access to the dashboard and all features.",
                "googleBtn": "Continue with Google",
                "redirecting": "Redirecting to Google...",
                "errorTitle": "Error",
                "almostDone": "Almost Done!",
                "enterPhone": "Enter your WhatsApp/Mobile number to complete your profile.",
                "loginAs": "Logged in as",
                "phoneLabel": "Mobile / WA Number",
                "phonePlaceholder": "62812xxxxxxxx (can also start with 08 / 8xx)",
                "phoneHint": "Number will be automatically normalized to 62xxxxxxxxxx format.",
                "saveBtn": "Done & Go to Dashboard →",
                "saving": "Saving...",
                "invalidPhone": "Invalid Mobile / WA Number format. Example: 62812xxxxxxx.",
                "sessionNotFound": "Login session not found. Please login again.",
                "saveError": "Failed to save mobile number: {{error}}"
            },
            "dashboard": {
                "welcome": "Welcome",
                "toNeo": "to Neo AI",
                "subtitle": "Limitless Creativity Platform Powered by AI",
                "description": "Neo AI brings the power of Artificial Intelligence into one integrated dashboard. Access various advanced tools to accelerate your work and realize your creative ideas.",
                "availableTools": "Your Available Tools",
                "activateTools": "Activate AI Tools Now!",
                "activateSubtitle": "Choose a package below to get access to various advanced AI tools",
                "noPackages": "No packages available at the moment. Contact admin to get tool access.",
                "popular": "Popular",
                "viewDetail": "View Detail",
                "claimFree": "Claim Free",
                "contactUs": "Contact Us",
                "free": "FREE",
                "getCredits": "Get {{count}} Credits"
            },
            "sidebar": {
                "workspace": "Workspace",
                "mainMenu": "Main Menu",
                "myTools": "My Tools",
                "home": "Home",
                "topup": "Topup Credit",
                "history": "History",
                "affiliator": "Affiliator",
                "logout": "Logout",
                "loggingOut": "Logging out...",
                "logoutError": "Failed to logout"
            },
            "history": {
                "pageTitle": "Generate History",
                "tabGenerate": "Generate",
                "tabTransaction": "Transactions",
                "rowsPerPage": "Rows per page:",
                "viewOptions": "View options",
                "layout": "Layout",
                "list": "List",
                "grid": "Grid",
                "imageSize": "Image Size",
                "tryAgain": "Try Again",
                "noHistory": "No history yet.",
                "endOfHistory": "End of History",
                "downloadFailed": "Download failed.",
                "downloadFile": "Download File",
                "date": "Date",
                "model": "Model",
                "creditStart": "Credit Start",
                "creditLeft": "Credit Left",
                "usage": "Usage",
                "txId": "Transaction ID",
                "amountPaid": "Amount Paid",
                "creditReceived": "Credit Received",
                "creditEnd": "Credit End",
                "status": "Status",
                "previous": "Previous",
                "next": "Next",
                "pageInfo": "Page {{current}} of {{total}}"
            },
            "topup": {
                "pageTitle": "Topup Credit",
                "loading": "Loading topup page...",
                "noPackages": "No active topup packages.",
                "popular": "Popular",
                "getCredits": "Get <0>{{count}} Credits</0>",
                "free": "Free",
                "perClaim": "/ 1x claim",
                "contactUs": "Contact Us",
                "claimFree": "Claim Free",
                "claimed": "Claimed",
                "buyNow": "Buy Now",
                "featureUnknown": "Package features not set in admin.",
                "filters": {
                    "all": "All",
                    "va": "Virtual Account",
                    "ew": "E-Wallet",
                    "qr": "QRIS",
                    "cc": "Card",
                    "eb": "E-Banking"
                },
                "modal": {
                    "titleClaim": "Claim Free Package",
                    "titleConfirm": "Confirm Purchase",
                    "descClaim": "Make sure you haven't claimed this before.",
                    "descConfirm": "Check package, voucher, then select payment method.",
                    "close": "Close",
                    "freePrice": "FREE / Rp 0",
                    "youGet": "You will get",
                    "onlyOnce": "Valid for 1x claim per user only.",
                    "cancel": "Cancel",
                    "processing": "Processing...",
                    "claimNow": "Claim Now",
                    "success": "Free package successfully claimed!",
                    "packageSelected": "Selected Package",
                    "priceDetails": "Price Details",
                    "voucherDiscount": "Voucher Discount",
                    "totalPay": "Total to pay",
                    "voucherLabel": "Voucher Code (optional)",
                    "voucherPlaceholder": "example: NEO-XXXXXX",
                    "checkingVoucher": "Checking voucher code...",
                    "voucherValid": "Voucher {{code}} is valid.",
                    "voucherInvalid": "Invalid or inactive voucher.",
                    "voucherOwnError": "Cannot use your own voucher.",
                    "voucherHint": "If you have a voucher, enter it here.",
                    "searchPlaceholder": "Search: BCA, Permata, OVO, QRIS...",
                    "noChannels": "No channels for this criteria.",
                    "fee": "Fee",
                    "payNow": "Pay Now",
                    "redirecting": "Redirecting...",
                    "errorSelectMethod": "Please select a payment method.",
                    "errorSession": "Login session expired, please login again.",
                    "errorClaim": "Failed to claim free package.",
                    "errorTransaction": "Failed to create transaction. Please try again.",
                    "errorNoUrl": "Transaction created, but payment URL not found.",
                    "errorGeneral": "An error occurred. Please try again later.",
                    "errorClaimedAlready": "You have already claimed this package. Free package can only be claimed once."
                }
            },
            "topupReturn": {
                "pageTitle": "Payment Status",
                "header": "Neo AI • Credit Topup",
                "status": {
                    "checking": {
                        "title": "Checking transaction status…",
                        "subtitle": "Please wait a moment, we are verifying your payment."
                    },
                    "pending": {
                        "title": "Waiting for payment confirmation",
                        "subtitle": "Waiting for confirmation from payment provider. This page will update automatically."
                    },
                    "paid": {
                        "title": "Payment successful",
                        "subtitle": "Payment successful and credits have been added to your account. If not visible, check Dashboard or refresh in a few seconds."
                    },
                    "failed": {
                        "title": "Transaction failed",
                        "subtitle": "Transaction failed or expired. Please try again."
                    }
                },
                "loading": "Loading transaction status...",
                "transactionDetail": "Transaction Detail",
                "merchantOrderId": "Merchant Order ID",
                "duitkuRef": "Duitku Ref",
                "summary": "Topup Summary",
                "amountPaid": "Amount Paid",
                "creditReceived": "Credit Received",
                "creditSuccess": "Credits have been added to your balance.",
                "toDashboard": "To Dashboard",
                "refreshStatus": "Refresh Status",
                "topupAgain": "Topup Again",
                "contactAdmin": "If balance doesn't update after retrying, please contact admin with the Merchant Order ID above.",
                "sessionExpired": "Login session expired. Please login again.",
                "checkFailed": "Failed to check transaction status.",
                "errorOccurred": "An error occurred.",
                "orderIdNotFound": "merchantOrderId not found."
            },
            "affiliator": {
                "loading": "Loading affiliator page...",
                "pageTitle": "Affiliator Program",
                "desc": "Share your affiliate coupon code and earn commission whenever a user tops up using that code.",
                "voucher": {
                    "title": "Affiliator Voucher",
                    "activeCode": "Active voucher code:",
                    "benefit": "Buyers using this code get <0>10% discount</0>, and you earn <1>{{rate}}% commission</1> from the discounted price.",
                    "noVoucher": "You don't have an affiliate voucher yet.",
                    "noVoucherDesc": "You can still view revenue simulation and T&C. To start using the affiliate program, create a voucher first.",
                    "copy": "Copy Voucher",
                    "copied": "Voucher code copied!",
                    "copyFail": "Failed to copy, please copy manually.",
                    "activeSince": "Active since",
                    "generate": "Generate Voucher",
                    "generating": "Generating...",
                    "confirmGenerate": "Generate affiliate voucher?\n\nThis voucher will be used by users during topup so the commission goes to your account.",
                    "successGenerate": "Voucher created successfully: {{code}}",
                    "failGenerate": "Failed to create voucher: {{error}}"
                },
                "tabs": {
                    "summary": "Summary",
                    "history": "Commission History",
                    "withdrawal": "Withdrawal",
                    "bank": "Bank/E-wallet Details"
                },
                "summary": {
                    "benefitTitle": "Benefits of Using Coupon Code",
                    "codeTitle": "Affiliate Coupon Code",
                    "buyerBenefit": "Buyer benefit: get <0>{{rate}}% discount from package price</0>.",
                    "yourBenefit": "Your benefit: get <0>{{rate}}% commission from discounted price</0> every time the coupon is used.",
                    "moreTrans": "The more transactions using your code, the greater your potential commission earnings.",
                    "tips": "Tips: Promote your code consistently. If performance is good, the commission percentage can be raised by admin.",
                    "statsTitle": "Brief Statistics",
                    "totalReferral": "Total Referrals",
                    "totalCommission": "Total Commission (all statuses)",
                    "statsDesc": "Data calculated from all transactions using your affiliate coupon code.",
                    "noVoucherStats": "You don't have an affiliate coupon code yet. Please <0>generate voucher</0> above to get a code you can share.",
                    "simulationTitle": "Revenue Simulation",
                    "simulationDesc": "Select a package bought via your coupon code, then enter how many times it's bought. System estimates revenue assuming <0>buyer gets {{discount}}% discount and you get {{commission}}% commission</0>.",
                    "noPackages": "No active packages yet. Add data in credit_packages table.",
                    "packageLabel": "Package Purchased",
                    "packagePlaceholder": "Select package to simulate",
                    "countLabel": "Transaction Count",
                    "countHint": "E.g. 10 purchases with your coupon code.",
                    "priceLabel": "Package Price (before discount)",
                    "discountLabel": "Discount for buyer:",
                    "netPriceLabel": "Price After Discount (paid by buyer)",
                    "estCommissionLabel": "Estimated Total Commission",
                    "commissionPerTx": "Commission per transaction: <0>{{amount}}</0> ({{rate}}% of discounted price).",
                    "termsTitle": "Terms & Conditions",
                    "termsDesc": "Important information about the affiliate program.",
                    "accordion": {
                        "howTo": "How to Earn Commission",
                        "howToItems": [
                            "Share the affiliate coupon code with potential buyers",
                            "Buyers use the coupon code when making a payment",
                            "Commission will be automatically added to your affiliate balance",
                            "You can withdraw commission funds after reaching minimum {{amount}}"
                        ],
                        "usage": "Coupon Usage",
                        "usageItems": [
                            "Coupon can only be used once by each different user.",
                            "Affiliators cannot use their own coupons for purchases.",
                            "Violation of these terms may result in disqualification from the affiliate program."
                        ],
                        "withdraw": "Withdrawal Requirements",
                        "withdrawItems": [
                            "Minimum balance {{amount}}",
                            "Must fill in bank account details correctly",
                            "Withdrawal process takes 1-3 working days",
                            "No admin fee for fund withdrawal"
                        ]
                    }
                },
                "history": {
                    "title": "Commission History",
                    "table": {
                        "date": "Date",
                        "buyer": "Buyer",
                        "affiliator": "Affiliator",
                        "code": "Coupon Code",
                        "count": "Trans Count",
                        "discount": "Discount",
                        "commission": "Commission"
                    },
                    "empty": "No commission data yet. Commissions will appear here for every transaction using your affiliate coupon code."
                },
                "withdraw": {
                    "title": "Request Commission Withdrawal",
                    "desc": "Withdrawal will deduct <0>entire balance</0> in your affiliate wallet. Minimum withdrawal <1>{{amount}}</1>.",
                    "balanceLabel": "Withdrawable Commission Balance",
                    "amountLabel": "Withdrawal Amount",
                    "amountHint": "Amount cannot be changed. System will withdraw all available commission balance.",
                    "lowBalance": "Insufficient balance. Minimum withdrawal {{amount}}.",
                    "noBank": "Complete bank/ewallet details in tab <0>Bank/E-wallet Details</0> first.",
                    "submit": "Withdraw All Balance",
                    "submitting": "Sending...",
                    "historyTitle": "Withdrawal History",
                    "table": {
                        "date": "Date",
                        "amount": "Amount",
                        "status": "Status",
                        "note": "Note"
                    },
                    "empty": "No withdrawal history yet. Your requests will appear here.",
                    "alertNoBank": "Complete bank/ewallet details in 'Bank/E-wallet Details' tab before requesting withdrawal.",
                    "alertFetchError": "Failed to read commission balance. Please try again later.",
                    "alertLowBalance": "Minimum withdrawal {{min}}. Your current balance {{current}}.",
                    "alertUpdateError": "Withdrawal requested but failed to update balance. Please contact admin.",
                    "alertSuccess": "Withdrawal request of {{amount}} sent. Status: pending.",
                    "alertFail": "Failed to request withdrawal: {{error}}"
                },
                "bank": {
                    "title": "Bank/E-wallet Details",
                    "desc": "Fill in bank/ewallet account details for affiliate commission withdrawal.",
                    "bankName": "Bank Name",
                    "bankPlaceholder": "e.g. BCA, BRI, Mandiri",
                    "accountNumber": "Account Number",
                    "accountPlaceholder": "e.g. 1234567890",
                    "accountHolder": "Account Holder Name",
                    "holderPlaceholder": "As in bank book",
                    "save": "Save Details",
                    "saving": "Saving...",
                    "alertEmpty": "All bank fields are required.",
                    "alertSuccess": "Bank/ewallet details saved successfully.",
                    "alertFail": "Failed to save bank/ewallet details: {{error}}"
                }
            },
            "features": {
                "title": "Why Choose NeoAI?",
                "subtitle": "Everything You Need. One platform for all your digital creative needs.",
                "socialMedia": {
                    "title": "Social Media Generator",
                    "desc": "Automate your social media content with advanced AI. Create captions, hashtags, and post ideas in seconds."
                },
                "tts": {
                    "title": "Text to Speech",
                    "desc": "Convert text into natural human voice. Supports various languages and intonations for your voice-over needs."
                },
                "imageToVideo": {
                    "title": "Image to Video",
                    "desc": "Bring static images to life into stunning animated videos. Perfect for ads, presentations, and creative content."
                },
                "adsGenerator": {
                    "title": "ADS Generator",
                    "desc": "Create selling ad copies and visual ad variations instantly for Facebook, Instagram, and Google Ads."
                },
                "imageEditing": {
                    "title": "Image Editing",
                    "desc": "Edit photos with high precision using AI. Remove backgrounds, enhance resolution, and manipulate objects easily."
                },
                "briefToImages": {
                    "title": "Brief to Images",
                    "desc": "Simply provide a short description (prompt), and our AI will generate high-quality images according to your imagination."
                },
                "brandingGenerator": {
                    "title": "Branding Generator",
                    "desc": "Create professional brand identities, logos, and style guides instantly."
                },
                "contentPlanner": {
                    "title": "Content Planner",
                    "desc": "Plan and schedule your content strategy efficiently with AI assistance."
                },
                "magicAi": {
                    "title": "Magic AI",
                    "desc": "Unlock limitless possibilities with our experimental AI tools."
                },
                "ugcGenerator": {
                    "title": "UGC Generator",
                    "desc": "Generate authentic User Generated Content scripts and ideas effectively."
                }
            },
            "pricing": {
                "title": "Buy now",
                "subtitle": "Choose a credit package that suits your needs.",
                "error": "Failed to load packages: {{error}}",
                "checkConfig": "Make sure Supabase client is initialized and RLS on table credit_packages is set to SELECT public!",
                "popular": "Popular",
                "featuresLabel": "Features you get",
                "featureUnknown": "Package features not set in admin.",
                "buyButton": "Buy {{name}}",
                "tryButton": "Try Now",
                "contactButton": "Contact Us"
            },
            "showcase": {
                "title": "Example Result: Magic AI",
                "subtitle": "These are samples from our Magic AI models. Access 10+ AI Tools and hundreds of AI models including Social Media Generator, Text to Speech, and Image to Video inside the dashboard.",
                "cta": "Explore All AI Models"
            },
            "authModal": {
                "title": "Quick Access",
                "desc": "Login or Register for instant access to all features.",
                "googleBtn": "Continue with Google",
                "redirecting": "Redirecting...",
                "close": "Close"
            },
            "footer": {
                "desc": "Everything You Need. One platform for all your digital creative needs.",
                "allSystems": "All systems operational",
                "product": "Product",
                "features": "Features",
                "pricing": "Pricing",
                "showcase": "Showcase",
                "sitemaps": "Site Maps",
                "home": "Home",
                "about": "About",
                "blog": "Blog",
                "contact": "Contact",
                "connect": "Connect",
                "policies": "Policies",
                "privacy": "Privacy",
                "terms": "Terms",
                "cookies": "Cookies",
                "rights": "All rights reserved."
            },
            "faq": {
                "title": "Frequently Asked Questions",
                "subtitle": "Everything you need to know about Neo AI.",
                "q1": "How long are my generated files stored?",
                "a1": "We store your generated images and videos for 30 days. After that period, the system automatically deletes them to maintain privacy and storage efficiency. Please download your assets immediately after generation.",
                "q2": "How does the credit system work?",
                "a2": "Credits are deducted each time you generate content. The cost varies by tool text-to-image might cost 1 credit, while video generation costs more. You only pay for what you use.",
                "q3": "Can I use the results specifically for commercial projects?",
                "a3": "Yes, absolutely! You own full commercial rights to all text, images, and videos you generate on Neo AI. You are free to use them for ads, client work, or social media.",
                "q4": "What if a generation fails? Do I lose credits?",
                "a4": "No. If the generation fails due to a system error, your credits will be automatically refunded or not deducted at all. We ensure you only pay for successful outputs.",
                "q5": "Is my data and uploaded content secure?",
                "a5": "Absolutely. We prioritize your privacy and data security with enterprise-grade encryption. Your uploads remain private and are never used to train public AI models without your explicit permission."
            },
            "ctaSection": {
                "title": "Ready to Transform Your Creative Workflow?",
                "subtitle": "Join thousands of creators who are already using Neo AI to produce stunning content in seconds.",
                "button": "Get Started for Free"
            },
            "howItWorks": {
                "title": "Your Entire Creative Team in One Dashboard",
                "subtitle": "Stop worrying about monthly salaries and management headaches. Neo AI replaces expensive overhead with intelligent automation.",
                "step1Title": "No More Expensive Hiring",
                "step1Desc": "Forget hiring graphic designers, copywriters, or video editors with high monthly salaries. Neo AI handles it all.",
                "step2Title": "Instant Results",
                "step2Desc": "Skip the endless feedback loops and waiting times. Generate professional assets in seconds, not weeks.",
                "step3Title": "Pay As You Grow",
                "step3Desc": "Why pay fixed salaries for idle time? With our credit system, you only pay for the content you actually create."
            },
            "comparison": {
                "title": "Why Neo AI is the Smart Choice",
                "subtitle": "Stop paying separately for text, image, and video tools. Get everything in one place.",
                "col1": "Freelancers / Agency",
                "col2": "Other AI Tools",
                "col3": "Neo AI",
                "row1": "Cost",
                "row1_cell1": "Expensive ($500+ / project)",
                "row1_cell2": "Multiple Subscriptions ($100+/mo)",
                "row1_cell3": "Affordable (Start Free)",
                "row2": "Speed",
                "row2_cell1": "Days or Weeks",
                "row2_cell2": "Fast",
                "row2_cell3": "Instant (Seconds)",
                "row3": "Accessibility",
                "row3_cell1": "Limited Hours",
                "row3_cell2": "Fragmented Accounts",
                "row3_cell3": "24/7 All-in-One Dashboard",
                "row4": "Revisions",
                "row4_cell1": "Extra Charge",
                "row4_cell2": "Standard",
                "row4_cell3": "Unlimited Regeneration",
                "row5": "Chat & Image Gen",
                "row5_cell1": "Separate Roles",
                "row5_cell2": "Separate Apps",
                "row5_cell3": "Integrated in One Platform",
                "row6": "Result Accuracy",
                "row6_cell1": "Often Misses Context",
                "row6_cell2": "Hard to Control",
                "row6_cell3": "Precise (Chat & Visual Integrated)"
            },
            "useCases": {
                "title": "Built for Every Visionary",
                "subtitle": "From solo founders to scaling agencies, Neo AI adapts to your workflow.",
                "agencyTitle": "Creative Agencies",
                "agencyDesc": "Scale production 10x without hiring more staff. Deliver client assets instantly.",
                "startupTitle": "Startup Founders",
                "startupDesc": "Build your MVP branding and pitch deck visuals in one afternoon.",
                "creatorTitle": "Content Creators",
                "creatorDesc": "Never run out of content. Generate thumbnails, shorts, and posts daily.",
                "marketingTitle": "Digital Marketers",
                "marketingDesc": "Create high-converting ad variations in seconds for A/B testing.",
                "ecommerceTitle": "E-commerce",
                "ecommerceDesc": "Turn boring product photos into lifestyle shots that sell.",
                "developerTitle": "Developers",
                "developerDesc": "Generate placeholders and UI assets without waiting for designers.",
                "businessTitle": "All Business Types",
                "businessDesc": "From retail to real estate, automate your daily content needs effortlessly.",
                "educationTitle": "Students & Educators",
                "educationDesc": "Enhance learning and research with AI-powered summaries and visual aids."
            }
        }
    },
    id: {
        translation: {
            "hero": {
                "title1": "Super AI",
                "title2": "untuk Semua Generasi",
                "desc": "Rasakan kekuatan AI tanpa batas. Neo AI menawarkan solusi lengkap untuk manajemen aplikasi dan kreativitas Anda dengan kecepatan kilat.",
                "ctaPrimary": "Mulai Gratis Sekarang",
                "ctaDashboard": "Masuk Dashboard →",
                "ctaChecking": "Memeriksa...",
                "ctaSecondary": "Tentang Kami"
            },
            "modelsMarquee": {
                "title": "Mesin Kelas Dunia",
                "subtitle": "Akses model generasi paling canggih."
            },
            "common": {
                "credits": "Kredit",
                "credit": "Kredit",
                "findInspiration": "Cari Inspirasi"
            },
            "nav": {
                "home": "Beranda",
                "about": "Tentang Kami",
                "blog": "Blog",
                "blog": "Blog",
                "login": "Masuk",
                "language": "Bahasa"
            },
            "blogPage": {
                "title": "Wawasan",
                "titleHighlight": "Terkini",
                "description": "Pelajari tips, trik, dan berita terbaru seputar artificial intelligence.",
                "searchPlaceholder": "Cari artikel...",
                "allTopics": "Semua Topik",
                "noResultsTitle": "Tidak ditemukan",
                "noResultsDesc": "Coba kata kunci lain atau ganti filter kategori.",
                "page": "Halaman",
                "of": "dari",
                "readMore": "Baca Selengkapnya"
            },
            "aboutPage": {
                "heroLabel": "Tentang NeoAI",
                "heroTitle": "Platform AI untuk konten yang lebih cepat.",
                "heroDesc": "NeoAI adalah platform SaaS yang membantu kreator, marketer, dan pelaku bisnis menghasilkan konten, mengelola kredit, dan memantau performa dengan antarmuka yang sederhana namun powerful — tanpa perlu pusing dengan teknis.",
                "visionLabel": "VISI KAMI",
                "visionText": "Menjadi asisten AI yang paling praktis dan terjangkau untuk membantu pengguna di Indonesia membuat konten dan mengelola aktivitas digital tanpa ribet — cukup dari satu dashboard saja.",
                "missionLabel": "MISI KAMI",
                "mission1Title": "01. Tools Praktis",
                "mission1Text": "Menyediakan tools AI yang mudah digunakan untuk kebutuhan harian seperti social media, copywriting, dan ide konten.",
                "mission2Title": "02. Kontrol Penuh",
                "mission2Text": "Memberikan kontrol penuh kepada pengguna melalui sistem kredit, riwayat transaksi, dan affiliate yang transparan.",
                "mission3Title": "03. Pengalaman Terbaik",
                "mission3Text": "Membangun pengalaman dashboard yang rapi, ringan, dan nyaman diakses dari berbagai perangkat.",
                "valuesLabel": "NILAI INTI",
                "value1Title": "Simple & Jelas",
                "value1Text": "Fokus pada hal yang benar-benar dipakai pengguna. Tidak over-complicated, tidak kebanyakan tombol.",
                "value2Title": "Terukur & Transparan",
                "value2Text": "Setiap top up, pemakaian kredit, sampai komisi affiliate bisa dilacak dari dashboard secara real-time.",
                "value3Title": "Tumbuh Bersama",
                "value3Text": "Affiliate & fitur-fitur baru dibangun supaya pengguna juga bisa ikut bertumbuh, bukan cuma pakai.",
                "backHome": "Kembali ke Beranda"
            },
            "login": {
                "title": "Masuk ke Neo AI",
                "description": "Gunakan akun Google Anda untuk akses cepat ke dashboard dan semua fitur.",
                "googleBtn": "Lanjutkan dengan Google",
                "redirecting": "Mengarahkan ke Google...",
                "errorTitle": "Error",
                "almostDone": "Hampir Selesai!",
                "enterPhone": "Masukkan nomor WhatsApp/HP Anda untuk melengkapi profil.",
                "loginAs": "Login sebagai",
                "phoneLabel": "Nomor Handphone / WA",
                "phonePlaceholder": "62812xxxxxxxx (boleh juga mulai 08 / 8xx)",
                "phoneHint": "Nomor akan dinormalisasi otomatis ke format 62xxxxxxxxxx.",
                "saveBtn": "Selesai & Masuk Dashboard →",
                "saving": "Menyimpan...",
                "invalidPhone": "Format Nomor HP / WA tidak valid. Contoh: 62812xxxxxxx.",
                "sessionNotFound": "Sesi login tidak ditemukan. Mohon login ulang.",
                "saveError": "Gagal menyimpan nomor HP: {{error}}"
            },
            "dashboard": {
                "welcome": "Selamat Datang",
                "toNeo": "di Neo AI",
                "subtitle": "Platform Kreativitas Tanpa Batas Berbasis AI",
                "description": "Neo AI menghadirkan kekuatan Artificial Intelligence dalam satu dashboard terintegrasi. Akses berbagai tool canggih untuk mempercepat pekerjaan dan mewujudkan ide kreatifmu.",
                "availableTools": "Tools Tersedia",
                "activateTools": "Aktifkan Tools AI Sekarang!",
                "activateSubtitle": "Pilih paket di bawah untuk mendapatkan akses ke berbagai AI tools canggih",
                "noPackages": "Tidak ada paket tersedia saat ini. Hubungi admin untuk mendapatkan akses tools.",
                "popular": "Populer",
                "viewDetail": "Lihat Detail",
                "claimFree": "Klaim Gratis",
                "contactUs": "Hubungi Kami",
                "free": "GRATIS",
                "getCredits": "Dapat {{count}} Kredit"
            },
            "sidebar": {
                "workspace": "Workspace",
                "mainMenu": "Menu Utama",
                "myTools": "Tools Saya",
                "home": "Beranda",
                "topup": "Isi Saldo",
                "history": "Riwayat",
                "affiliator": "Affiliator",
                "logout": "Keluar",
                "loggingOut": "Keluar...",
                "logoutError": "Gagal keluar"
            },
            "history": {
                "pageTitle": "Riwayat Generate",
                "tabGenerate": "Generate",
                "tabTransaction": "Transaksi",
                "rowsPerPage": "Baris per halaman:",
                "viewOptions": "Opsi Tampilan",
                "layout": "Tata Letak",
                "list": "Daftar",
                "grid": "Kisi",
                "imageSize": "Ukuran Gambar",
                "tryAgain": "Coba Lagi",
                "noHistory": "Belum ada riwayat.",
                "endOfHistory": "Akhir dari Riwayat",
                "downloadFailed": "Gagal mengunduh file.",
                "downloadFile": "Unduh File",
                "date": "Tanggal",
                "model": "Model",
                "creditStart": "Kredit Awal",
                "creditLeft": "Kredit Sisa",
                "usage": "Pemakaian",
                "txId": "ID Transaksi",
                "amountPaid": "Nominal Bayar",
                "creditReceived": "Kredit Diterima",
                "creditEnd": "Kredit Akhir",
                "status": "Status",
                "previous": "Sebelumnya",
                "next": "Selanjutnya",
                "pageInfo": "Halaman {{current}} dari {{total}}"
            },
            "topup": {
                "pageTitle": "Isi Saldo",
                "loading": "Memuat halaman topup...",
                "noPackages": "Tidak ada paket topup aktif.",
                "popular": "Populer",
                "getCredits": "Dapat <0>{{count}} Kredit</0>",
                "free": "Gratis",
                "perClaim": "/ 1x klaim",
                "contactUs": "Hubungi Kami",
                "claimFree": "Klaim Gratis",
                "claimed": "Sudah Diklaim",
                "buyNow": "Beli Sekarang",
                "featureUnknown": "Fitur paket belum diatur di admin.",
                "filters": {
                    "all": "Semua",
                    "va": "Virtual Account",
                    "ew": "E-Wallet",
                    "qr": "QRIS",
                    "cc": "Kartu",
                    "eb": "E-Banking"
                },
                "modal": {
                    "titleClaim": "Klaim Paket Gratis",
                    "titleConfirm": "Konfirmasi Pembelian",
                    "descClaim": "Pastikan Anda belum pernah mengklaim ini sebelumnya.",
                    "descConfirm": "Cek paket, voucher, lalu pilih metode pembayaran.",
                    "close": "Tutup",
                    "freePrice": "GRATIS / Rp 0",
                    "youGet": "Anda akan mendapatkan",
                    "onlyOnce": "Hanya berlaku untuk 1x klaim per user.",
                    "cancel": "Batal",
                    "processing": "Memproses...",
                    "claimNow": "Klaim Sekarang",
                    "success": "Paket gratis berhasil diklaim!",
                    "packageSelected": "Paket dipilih",
                    "priceDetails": "Rincian harga",
                    "voucherDiscount": "Diskon voucher",
                    "totalPay": "Total bayar",
                    "voucherLabel": "Kode voucher (opsional)",
                    "voucherPlaceholder": "contoh: NEO-XXXXXX",
                    "checkingVoucher": "Memeriksa kode voucher...",
                    "voucherValid": "Voucher {{code}} valid.",
                    "voucherInvalid": "Voucher tidak valid / nonaktif.",
                    "voucherOwnError": "Tidak bisa menggunakan voucher milik sendiri.",
                    "voucherHint": "Jika punya voucher, masukkan di sini.",
                    "searchPlaceholder": "Cari: BCA, Permata, OVO, QRIS...",
                    "noChannels": "Tidak ada channel untuk kriteria ini.",
                    "fee": "Fee",
                    "payNow": "Bayar Sekarang",
                    "redirecting": "Mengalihkan...",
                    "errorSelectMethod": "Silakan pilih metode pembayaran.",
                    "errorSession": "Sesi login berakhir, silakan login ulang.",
                    "errorClaim": "Gagal mengklaim paket gratis.",
                    "errorTransaction": "Gagal membuat transaksi. Coba lagi beberapa saat.",
                    "errorNoUrl": "Transaksi dibuat, tapi URL pembayaran tidak ditemukan.",
                    "errorGeneral": "Terjadi kesalahan. Coba lagi nanti.",
                    "errorClaimedAlready": "Anda sudah pernah mengklaim paket ini. Paket free hanya bisa diklaim satu kali."
                }
            },
            "topupReturn": {
                "pageTitle": "Status Pembayaran",
                "header": "Neo AI • Topup Kredit",
                "status": {
                    "checking": {
                        "title": "Memeriksa status transaksi…",
                        "subtitle": "Mohon tunggu sebentar, kami sedang mengecek pembayaran Anda."
                    },
                    "pending": {
                        "title": "Menunggu konfirmasi pembayaran",
                        "subtitle": "Menunggu konfirmasi dari penyedia pembayaran. Halaman ini akan memperbarui otomatis."
                    },
                    "paid": {
                        "title": "Pembayaran berhasil",
                        "subtitle": "Pembayaran berhasil dan kredit sudah ditambahkan ke akun Anda. Jika belum terlihat, coba cek Dashboard atau refresh beberapa detik lagi."
                    },
                    "failed": {
                        "title": "Transaksi gagal",
                        "subtitle": "Transaksi gagal atau kadaluarsa. Silakan coba lagi."
                    }
                },
                "loading": "Sedang memuat status transaksi...",
                "transactionDetail": "Detail Transaksi",
                "merchantOrderId": "Merchant Order ID",
                "duitkuRef": "Ref Duitku",
                "summary": "Ringkasan Topup",
                "amountPaid": "Jumlah Dibayar",
                "creditReceived": "Kredit Diterima",
                "creditSuccess": "Kredit sudah ditambahkan ke saldo Anda.",
                "toDashboard": "Ke Dashboard",
                "refreshStatus": "Refresh Status",
                "topupAgain": "Topup Lagi",
                "contactAdmin": "Jika saldo tidak berubah setelah mencoba lagi, silakan hubungi admin dengan menyertakan Merchant Order ID di atas.",
                "sessionExpired": "Sesi login berakhir. Silakan login ulang.",
                "checkFailed": "Gagal memeriksa status transaksi.",
                "errorOccurred": "Terjadi kesalahan.",
                "orderIdNotFound": "merchantOrderId tidak ditemukan."
            },
            "affiliator": {
                "loading": "Memuat halaman affiliator...",
                "pageTitle": "Program Affiliator",
                "desc": "Bagikan kode kupon afiliasi-mu dan dapatkan komisi setiap ada user yang topup menggunakan kode tersebut.",
                "voucher": {
                    "title": "Voucher Affiliator",
                    "activeCode": "Kode voucher aktif:",
                    "benefit": "Pembeli yang menggunakan kode ini akan mendapat <0>potongan 10%</0>, dan kamu sebagai affiliator akan mendapat <1>komisi {{rate}}% dari harga setelah diskon</1>.",
                    "noVoucher": "Kamu belum memiliki voucher affiliate.",
                    "noVoucherDesc": "Kamu tetap bisa melihat simulasi pendapatan dan Syarat & Ketentuan. Untuk mulai menggunakan program afiliasi, buat voucher terlebih dahulu.",
                    "copy": "Salin voucher",
                    "copied": "Kode voucher disalin!",
                    "copyFail": "Gagal menyalin, silakan salin manual.",
                    "activeSince": "Aktif sejak",
                    "generate": "Generate voucher",
                    "generating": "Membuat voucher...",
                    "confirmGenerate": "Generate voucher affiliate?\n\nVoucher ini akan digunakan user saat topup agar komisi masuk ke akunmu.",
                    "successGenerate": "Voucher berhasil dibuat: {{code}}",
                    "failGenerate": "Gagal membuat voucher: {{error}}"
                },
                "tabs": {
                    "summary": "Ringkasan",
                    "history": "Riwayat Komisi",
                    "withdrawal": "Penarikan",
                    "bank": "Detail Bank/E-wallet"
                },
                "summary": {
                    "benefitTitle": "Keuntungan Menggunakan Kode Kupon",
                    "codeTitle": "Kode Kupon Afiliasi",
                    "buyerBenefit": "Keuntungan pembeli: mendapatkan potongan <0>{{rate}}% dari harga paket</0>.",
                    "yourBenefit": "Keuntunganmu: mendapatkan komisi <0>{{rate}}% dari harga setelah diskon</0> setiap kali kupon dipakai.",
                    "moreTrans": "Semakin banyak transaksi memakai kodemu, semakin besar potensi penghasilanmu dari komisi.",
                    "tips": "Tips: Promosikan kodemu secara konsisten. Jika performa bagus, persentase komisi bisa dinaikkan oleh admin.",
                    "statsTitle": "Statistik Singkat",
                    "totalReferral": "Total Referral",
                    "totalCommission": "Total Komisi (semua status)",
                    "statsDesc": "Data di atas dihitung dari seluruh transaksi yang menggunakan kode kupon afiliasi kamu.",
                    "noVoucherStats": "Kamu belum memiliki kode kupon afiliasi. Silakan <0>generate voucher</0> di bagian atas untuk mendapatkan kode yang bisa dibagikan ke calon pembeli.",
                    "simulationTitle": "Simulasi Pendapatan dari Voucher",
                    "simulationDesc": "Pilih paket yang dibeli melalui kode kupon milikmu, lalu masukkan berapa kali paket tersebut dibeli. Sistem akan menghitung estimasi pendapatan dengan asumsi <0>pembeli mendapat diskon {{discount}}% dan kamu mendapat komisi {{commission}}% dari harga setelah diskon</0>.",
                    "noPackages": "Belum ada paket aktif. Tambahkan data di tabel credit_packages.",
                    "packageLabel": "Paket yang dibeli",
                    "packagePlaceholder": "Pilih paket untuk disimulasikan",
                    "countLabel": "Jumlah transaksi menggunakan kupon",
                    "countHint": "Misalnya ada 10 pembelian dengan kode kupon milikmu.",
                    "priceLabel": "Harga Paket (sebelum diskon)",
                    "discountLabel": "Diskon untuk pembeli:",
                    "netPriceLabel": "Harga Setelah Diskon (dibayar pembeli)",
                    "estCommissionLabel": "Estimasi Total Komisi",
                    "commissionPerTx": "Komisi per transaksi: <0>{{amount}}</0> ({{rate}}% dari harga setelah diskon).",
                    "termsTitle": "Syarat & Ketentuan",
                    "termsDesc": "Informasi penting tentang program afiliasi.",
                    "accordion": {
                        "howTo": "Cara Mendapatkan Komisi",
                        "howToItems": [
                            "Bagikan kode kupon afiliasi kepada calon pembeli",
                            "Pembeli menggunakan kode kupon saat melakukan pembayaran",
                            "Komisi akan otomatis ditambahkan ke saldo afiliasi Anda",
                            "Anda dapat menarik dana komisi setelah mencapai minimum {{amount}}"
                        ],
                        "usage": "Penggunaan Kupon",
                        "usageItems": [
                            "Kupon hanya dapat digunakan satu kali oleh setiap pengguna yang berbeda.",
                            "Affiliator tidak dapat menggunakan kupon miliknya sendiri dan orang lain untuk melakukan pembelian.",
                            "Pelanggaran terhadap ketentuan ini dapat menyebabkan diskualifikasi dari program afiliasi."
                        ],
                        "withdraw": "Persyaratan Penarikan Dana",
                        "withdrawItems": [
                            "Saldo minimum {{amount}}",
                            "Harus mengisi detail rekening bank dengan benar",
                            "Proses penarikan dana memerlukan waktu 1-3 hari kerja",
                            "Tidak ada biaya admin untuk penarikan dana"
                        ]
                    }
                },
                "history": {
                    "title": "Riwayat Komisi",
                    "table": {
                        "date": "Tanggal",
                        "buyer": "Pembeli",
                        "affiliator": "Affiliator",
                        "code": "Kode Kupon",
                        "count": "Jumlah Transaksi",
                        "discount": "Diskon",
                        "commission": "Komisi"
                    },
                    "empty": "Belum ada data komisi. Komisi akan muncul di sini setiap ada transaksi yang menggunakan kode kupon afiliasi milikmu."
                },
                "withdraw": {
                    "title": "Ajukan Penarikan Komisi",
                    "desc": "Penarikan akan mengurangi <0>seluruh saldo</0> di dompet afiliasi kamu. Minimal penarikan <1>{{amount}}</1>.",
                    "balanceLabel": "Saldo komisi yang bisa ditarik",
                    "amountLabel": "Nominal penarikan",
                    "amountHint": "Nominal tidak bisa diubah. Sistem akan menarik seluruh saldo komisi yang tersedia.",
                    "lowBalance": "Saldo belum cukup. Minimal penarikan {{amount}}.",
                    "noBank": "Lengkapi dulu detail bank/ewallet di tab <0>Detail Bank/E-wallet</0>.",
                    "submit": "Tarik Semua Saldo",
                    "submitting": "Mengirim...",
                    "historyTitle": "Riwayat Penarikan",
                    "table": {
                        "date": "Tanggal",
                        "amount": "Nominal",
                        "status": "Status",
                        "note": "Catatan"
                    },
                    "empty": "Belum ada riwayat penarikan. Pengajuan yang kamu kirim akan muncul di sini.",
                    "alertNoBank": "Lengkapi dulu detail bank/ewallet di tab 'Detail Bank/E-wallet' sebelum mengajukan penarikan.",
                    "alertFetchError": "Gagal membaca saldo komisi. Coba lagi beberapa saat lagi.",
                    "alertLowBalance": "Minimal penarikan {{min}}. Saldo kamu saat ini {{current}}.",
                    "alertUpdateError": "Penarikan berhasil diajukan, tapi gagal mengupdate saldo. Silakan hubungi admin.",
                    "alertSuccess": "Pengajuan penarikan sebesar {{amount}} terkirim. Status: pending.",
                    "alertFail": "Gagal mengajukan penarikan: {{error}}"
                },
                "bank": {
                    "title": "Detail Bank/E-wallet",
                    "desc": "Isi detail rekening bank/ewallet untuk penarikan komisi afiliasi.",
                    "bankName": "Nama Bank",
                    "bankPlaceholder": "contoh: BCA, BRI, Mandiri",
                    "accountNumber": "Nomor Rekening",
                    "accountPlaceholder": "contoh: 1234567890",
                    "accountHolder": "Nama Pemilik Rekening",
                    "holderPlaceholder": "Sesuai di buku tabungan",
                    "save": "Simpan Detail Bank /E-wallet",
                    "saving": "Menyimpan...",
                    "alertEmpty": "Semua field bank wajib diisi.",
                    "alertSuccess": "Detail bank/ewallet berhasil disimpan.",
                    "alertFail": "Gagal menyimpan detail bank/ewallet: {{error}}"
                }
            },
            "features": {
                "title": "Kenapa Memilih NeoAI?",
                "subtitle": "Semua yang Anda butuhkan. Satu platform untuk semua kebutuhan kreatif digital Anda.",
                "socialMedia": {
                    "title": "Social Media Generator",
                    "desc": "Otomatisasi konten sosial media Anda dengan AI canggih. Buat caption, hashtag, dan ide postingan dalam hitungan detik."
                },
                "tts": {
                    "title": "Text to Speech",
                    "desc": "Ubah teks menjadi suara manusia yang natural. Mendukung berbagai bahasa dan intonasi untuk kebutuhan voice-over Anda."
                },
                "imageToVideo": {
                    "title": "Image to Video",
                    "desc": "Hidupkan gambar statis menjadi video animasi yang memukau. Cocok untuk iklan, presentasi, dan konten kreatif."
                },
                "adsGenerator": {
                    "title": "ADS Generator",
                    "desc": "Buat copy iklan yang menjual dan variasi visual iklan secara instan untuk Facebook, Instagram, dan Google Ads."
                },
                "imageEditing": {
                    "title": "Image Editing",
                    "desc": "Edit foto dengan presisi tinggi menggunakan AI. Hapus background, tingkatkan resolusi, dan manipulasi objek dengan mudah."
                },
                "briefToImages": {
                    "title": "Brief to Images",
                    "desc": "Cukup berikan deskripsi singkat (prompt), dan AI kami akan menghasilkan gambar berkualitas tinggi sesuai imajinasi Anda."
                },
                "brandingGenerator": {
                    "title": "Branding Generator",
                    "desc": "Buat identitas brand, logo, dan panduan gaya profesional secara instan."
                },
                "contentPlanner": {
                    "title": "Content Planner",
                    "desc": "Rencanakan dan jadwalkan strategi konten Anda secara efisien dengan bantuan AI."
                },
                "magicAi": {
                    "title": "Magic AI",
                    "desc": "Temukan kemungkinan tanpa batas dengan alat AI eksperimental kami."
                },
                "ugcGenerator": {
                    "title": "UGC Generator",
                    "desc": "Hasilkan skrip dan ide User Generated Content yang otentik secara efektif."
                }
            },
            "pricing": {
                "title": "Beli Sekarang",
                "subtitle": "Pilih paket kredit yang sesuai dengan kebutuhan Anda.",
                "error": "Gagal memuat paket: {{error}}",
                "checkConfig": "Pastikan Supabase klien sudah terinisialisasi dan RLS di tabel credit_packages sudah disetting untuk SELECT publik!",
                "popular": "Populer",
                "featuresLabel": "Fitur yang Anda dapatkan",
                "featureUnknown": "Fitur paket belum diatur di admin.",
                "buyButton": "Beli {{name}}",
                "tryButton": "Coba Sekarang",
                "contactButton": "Hubungi Kami"
            },
            "showcase": {
                "title": "Contoh Hasil: Magic AI",
                "subtitle": "Ini adalah contoh dari alat Magic AI kami. Akses 10+ Alat AI dan ratusan model AI termasuk Social Media Generator, Text to Speech, dan Image to Video di dalam dashboard.",
                "cta": "Jelajahi Semua Model AI"
            },
            "authModal": {
                "title": "Akses Cepat",
                "desc": "Masuk atau Daftar untuk akses instan ke semua fitur.",
                "googleBtn": "Lanjutkan dengan Google",
                "redirecting": "Mengarahkan...",
                "close": "Tutup"
            },
            "footer": {
                "desc": "Semua yang Anda butuhkan. Satu platform untuk semua kebutuhan kreatif digital Anda.",
                "allSystems": "Semua sistem beroperasi",
                "product": "Produk",
                "features": "Fitur",
                "pricing": "Harga",
                "showcase": "Showcase",
                "sitemaps": "Peta Situs",
                "home": "Beranda",
                "about": "Tentang Kami",
                "blog": "Blog",
                "contact": "Kontak",
                "connect": "Hubungkan",
                "policies": "Kebijakan",
                "privacy": "Privasi",
                "terms": "Syarat & Ketentuan",
                "cookies": "Cookies",
                "rights": "Hak Cipta Dilindungi."
            },
            "faq": {
                "title": "Pertanyaan yang Sering Diajukan",
                "subtitle": "Semua yang perlu Anda ketahui tentang Neo AI.",
                "q1": "Berapa lama file hasil generate disimpan?",
                "a1": "Kami menyimpan gambar dan video hasil generate Anda selama 30 hari di server. Setelah 30 hari, file akan dihapus otomatis oleh sistem demi privasi dan efisiensi penyimpanan. Pastikan Anda segera mengunduh aset penting Anda.",
                "q2": "Bagaimana cara kerja sistem kredit?",
                "a2": "Kredit akan berkurang setiap kali Anda melakukan generate konten. Jumlah potongan tergantung alat yang digunakan (misal: Text-to-Image 1 kredit, Video lebih besar). Penggunaan transparan dan sesuai pemakaian.",
                "q3": "Apakah hasil generate boleh dikomersilkan?",
                "a3": "Ya, tentu saja! Anda memiliki hak komersial penuh atas semua teks, gambar, dan video yang Anda buat di Neo AI. Anda bebas menggunakannya untuk iklan, proyek klien, merchandise, atau konten monetisasi.",
                "q4": "Bagaimana jika proses generate gagal? Apakah kredit hilang?",
                "a4": "Tidak. Jika proses generate gagal karena kesalahan sistem, kredit Anda akan otomatis dikembalikan atau tidak terpotong sama sekali. Anda hanya membayar untuk hasil yang sukses.",
                "q5": "Apakah data dan konten yang saya unggah aman?",
                "a5": "Tentu saja. Kami memprioritaskan privasi dan keamanan data Anda dengan enkripsi tingkat perusahaan. Unggahan Anda bersifat pribadi dan tidak pernah digunakan untuk melatih model AI publik tanpa izin Anda."
            },
            "ctaSection": {
                "title": "Siap Mengubah Cara Anda Berkarya?",
                "subtitle": "Bergabunglah dengan ribuan kreator yang telah menggunakan Neo AI untuk menghasilkan konten memukau dalam hitungan detik.",
                "button": "Mulai Gratis Sekarang"
            },
            "howItWorks": {
                "title": "Tim Kreatif Lengkap dalam Satu Dashboard",
                "subtitle": "Berhenti pusing dengan gaji bulanan dan manajemen karyawan. Neo AI menggantikan biaya operasional mahal dengan otomatisasi cerdas.",
                "step1Title": "Tanpa Biaya Rekrutmen Mahal",
                "step1Desc": "Lupakan merekrut desainer, copywriter, atau editor video dengan gaji bulanan yang tinggi. Neo AI menangani semuanya.",
                "step2Title": "Hasil Instan",
                "step2Desc": "Lewati proses revisi yang panjang dan waktu tunggu lama. Hasilkan aset profesional dalam hitungan detik, bukan minggu.",
                "step3Title": "Bayar Sesuai Kebutuhan",
                "step3Desc": "Kenapa bayar gaji tetap saat tidak ada proyek? Dengan sistem kredit kami, Anda hanya membayar untuk konten yang Anda buat."
            },
            "comparison": {
                "title": "Kenapa Neo AI Pilihan Paling Cerdas?",
                "subtitle": "Berhenti membayar terpisah untuk alat teks, gambar, dan video. Dapatkan semuanya di satu tempat.",
                "col1": "Freelancer / Agensi",
                "col2": "Tools AI Lain",
                "col3": "Neo AI",
                "row1": "Biaya",
                "row1_cell1": "Mahal (Jutaan / project)",
                "row1_cell2": "Langganan Ganda (Ratusan Ribu/bln)",
                "row1_cell3": "Terjangkau (Mulai Gratis)",
                "row2": "Kecepatan",
                "row2_cell1": "Hitungan Hari / Minggu",
                "row2_cell2": "Cepat",
                "row2_cell3": "Instan (Detik)",
                "row3": "Aksesibilitas",
                "row3_cell1": "Jam Kerja Terbatas",
                "row3_cell2": "Akun Terpisah-pisah",
                "row3_cell3": "24/7 Satu Dashboard",
                "row4": "Revisi",
                "row4_cell1": "Kena Biaya Tambahan",
                "row4_cell2": "Standar",
                "row4_cell3": "Generate Ulang Sepuasnya",
                "row5": "Chat & Image Gen",
                "row5_cell1": "Peran Terpisah",
                "row5_cell2": "Aplikasi Terpisah",
                "row5_cell3": "Terintegrasi Satu Platform",
                "row6": "Kesesuaian Hasil",
                "row6_cell1": "Sering Salah Paham",
                "row6_cell2": "Sulit Dikontrol",
                "row6_cell3": "Pasti Sesuai (Integrasi Chat & Visual)"
            },
            "useCases": {
                "title": "Dibuat untuk Setiap Visioner",
                "subtitle": "Dari pendiri solo hingga agensi yang berkembang, Neo AI beradaptasi dengan alur kerja Anda.",
                "agencyTitle": "Agensi Kreatif",
                "agencyDesc": "Skala produksi 10x tanpa rekrut staf baru. Kirim aset klien secara instan.",
                "startupTitle": "Pendiri Startup",
                "startupDesc": "Buat branding MVP dan visual pitch deck Anda dalam satu sore.",
                "creatorTitle": "Kreator Konten",
                "creatorDesc": "Jangan pernah kehabisan konten. Buat thumbnail, shorts, dan postingan setiap hari.",
                "marketingTitle": "Pemasar Digital",
                "marketingDesc": "Buat variasi iklan konversi tinggi dalam hitungan detik untuk A/B testing.",
                "ecommerceTitle": "E-commerce",
                "ecommerceDesc": "Ubah foto produk membosankan menjadi foto gaya hidup yang menjual.",
                "developerTitle": "Developer",
                "developerDesc": "Hasilkan placeholder dan aset UI tanpa menunggu desainer.",
                "businessTitle": "Semua Jenis Bisnis",
                "businessDesc": "Dari ritel hingga real estat, otomatiskan kebutuhan konten harian Anda dengan mudah.",
                "educationTitle": "Pelajar & Pendidik",
                "educationDesc": "Tingkatkan pembelajaran dan riset dengan ringkasan dan alat visual berbasis AI."
            }
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // Set default to English as requested
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        }
    });

export default i18n;
